import CalcView, { ICalcComponent } from './CalcView'

export { CalcView, ICalcComponent }
